export const COMPONENT_NAME = 'FavoriteSubLayout';

export const LISTINGLAYOUT_COMPONENT = 'Favorite_Listing_layout';
export const FILTER_SECTION = 'filter_section';
export const SMARTLIST_SECTION = 'smart_list_section';
export const FILTEREEDLIST_SECTION = 'filtered_list_section';
